import React, { useState, useEffect } from "react";
import { $t } from "@/modules/i18n";
import Logo from "@/assets/images/logo.svg";
import Menu from "@tc/assets/icons/menu.svg";
import Close from "@tc/assets/icons/close.svg";
import { fixHtmlAndBody, looseHtmlAndBody } from '@/utils/helper'

const NavList = ({ message, hash }) => (
  <ul
    className="nav"
    data-easing="easeInOutExpo"
    data-speed="1250"
    data-offset="65"
  >
    {message.map(
      item =>
        !item.hide ? (
          <li
            className={`nav-item${hash === item.href ? " active" : ""}${
              item.class ? " " + item.class : ""
            }`}
            key={item.text}
          >
            <a
              className="nav-link"
              href={item.href}
              target={item.target ? item.target : "_self"}
              rel={item.target ? "noopener noreferrer" : ""}
            >
              {$t(item.text)}
            </a>
          </li>
        ) : null
    )}
  </ul>
);

export default ({ message = [], children }) => {
  const [hash, setHash] = useState("");
  const [menuShow, setMenuShow] = useState(false);
  
  function menuShowChange(menuShow) {
    if (menuShow) {
      fixHtmlAndBody();
      // el.addEventListener('touchmove', (e) => e.preventDefault());
      return;
    }
    // el.removeEventListener('touchmove', (e) => e.preventDefault());
    looseHtmlAndBody();
  }

  function updateHash() {
    setHash(window.location.hash);
  }

  useEffect(() => {
    window.addEventListener("hashchange", updateHash);
    return () => window.removeEventListener("hashchange", updateHash);
  }, []);

  useEffect(() => {
    setHash(window.location.hash);
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-collapse" id="navbarNavDropdown">
        <div className="container">
          {children ? (
            children
          ) : (
            <a className="logo-group" href="/">
              <img className="logo" src={Logo} alt="Shopee Logo" />
              <span className="logo-text">Careers</span>
            </a>
          )}
          <NavList message={message} hash={hash}/>
          <div className="icon-container">
            <img
              onClick={() => {setMenuShow(true); menuShowChange(true); }}
              className={!menuShow ? "menu-icon active" : "menu-icon"}
              src={Menu}
            />
            <img
              onClick={() => {setMenuShow(false); menuShowChange(false);}}
              className={menuShow ? "menu-icon active" : "menu-icon"}
              src={Close}
            />
          </div>
        </div>
      </div>
      <div className={menuShow ? "pop-up active" : "pop-up"} >
        <NavList message={message} hash={hash}/>
      </div>
      <div onClick={() => {setMenuShow(false); menuShowChange(false);}} id="nav-overlay" className={menuShow ? 'overlay' : null}></div>
    </nav>
  );
};
